import { render, staticRenderFns } from "./employees_details.vue?vue&type=template&id=1863060e&scoped=true"
import script from "./employees_details.vue?vue&type=script&lang=js"
export * from "./employees_details.vue?vue&type=script&lang=js"
import style0 from "./employees_details.vue?vue&type=style&index=0&id=1863060e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863060e",
  null
  
)

export default component.exports